import { render, staticRenderFns } from "./OnboardingFormTab.vue?vue&type=template&id=46da2a02&"
import script from "./OnboardingFormTab.vue?vue&type=script&lang=js&"
export * from "./OnboardingFormTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports